<!--
 * @FileDescription: 猜你喜欢页面
 * @Author: 陈文景
 * @Date: 2023-02-03 14:12:45
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <section class="container">
    <header class="header">
      <el-popover placement="bottom-start" :append-to-body="false" width="468" trigger="click">
        <div>
          <p class="popover-tips">新增的商品将出现在已有商品的后方，最多可添加{{ limitQuantity }}个商品！</p>

          <el-input v-model="spus" type="textarea" :autosize="{ minRows: 6, maxRows: 12 }" class="spus-input" :placeholder="`多个SPU请换行分割`" />

          <div class="footer-botton">
            <el-button size="mini" :disabled="spus ? false : true" @click="clearBatchAdd">清空</el-button>
            <el-button type="primary" size="mini" :disabled="spus ? false : true" @click="defineBatchAdd">确定</el-button>
          </div>
        </div>
        <el-button slot="reference" type="primary" size="medium">批量添加</el-button>
      </el-popover>

      <el-button type="warning" size="medium" :disabled="searchs.length ? true : false" class="update-button" @click="updateToReception">更新前台</el-button>

      <div class="header-search">
        <div class="search">
          <BatchSearchOne @clear="handleClearBatchSearchOne" @search="handleSearchBatchSearchOne" />
          <span class="tips">
            <strong>Tips：</strong>
            <p>1.可直接拖拽商品进行排序。</p>
            <p>2.可单击多个商品实现多选拖拽排序。</p>
            <p>3.可按住Shift键选择指定范围内的商品实现多选拖拽排序。</p>
          </span>
        </div>
        <el-button size="medium" :disabled="!goods.length || searchs.length ? true : false" @click="oneClickDeletion">一键删除</el-button>
      </div>
    </header>

    <ul id="kaka-drag-goods" class="goods">
      <li v-for="good in revealData" :key="good.kkProductId" :data-good-id="good.kkProductId" :class="[{ 'kaka-drag-good': good.top === 0 }, 'good']">
        <div :class="['good-img', { 'no-drop': good.top === 1 }, { 'kaka-drag-good-img': good.top === 0 }]">
          <img :src="good.imgUrl" alt="good.png" />
        </div>

        <p class="spu">
          <span class="label">SPU: </span>
          <span class="value">{{ good.spuCode }}</span>
        </p>

        <p class="price">
          <span class="label">$</span>
          <span class="value">{{ good.price }}</span>
        </p>

        <img v-if="good.top === 1" src="~@/assets/img/istop.png" class="istop-img" alt="istop.png" />

        <div class="footer">
          <div>
            <i class="iconfont icon-fuzhi1" @click="(event) => onCopy(good.spuCode, event)" />
            <i :class="['fixed-nail', 'iconfont', 'icon-igw-l-sign', 'nail', { active: good.top === 1 }]" @click="(event) => onIsTopGood(good, event)" />
            <i class="iconfont icon-a-delete-bin-6-line5" @click="(event) => onDeleteGood(good, event)" />
          </div>
        </div>
      </li>
    </ul>

    <!-- 空状态 -->
    <div v-show="!revealData.length" class="not-data">
      <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
      <span class="tips-text">No Record</span>
    </div>
  </section>
</template>

<script>
import API from '@/api'
import uniq from 'lodash/uniq'
import { copy } from '@/utils/copy'
import isEqual from 'lodash/isEqual'
import { Sortable } from 'sortablejs'
import unionWith from 'lodash/unionWith'
import cloneDeep from 'lodash/cloneDeep'
import Goods from '@/components/Goods.vue'
import BatchSearchOne from './components/BatchSearchOne.vue'

// let goods = []

// for (let i = 1; i <= 1; i++) {
//   goods.push({ kkProductId: i, spuCode: `HGGGFFFTT${i}`, price: `10${i}.00`, top: [].includes(i) ? 1 : 0, imgUrl: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg' })
// }

export default {
  name: 'operation_introduce',
  data() {
    return {
      sortable: null, // 拖拽插件的实例

      spus: undefined,

      keywords: [], // 搜索关键字
      searchs: [], // 根据搜索关键字筛选出来的商品
      disabled: false, // 是否禁用拖拽排序（当是搜索时则禁用）

      isTopSum: 5, // 最多可置顶的数量

      goods: [], // 商品数据（唯一数据源）
      selectIds: [], // 当前选中的Ids

      limitQuantity: 50 // 最大限制数量
    }
  },
  components: {
    Goods,
    BatchSearchOne
  },
  computed: {
    revealData() {
      if (this.keywords.length) {
        return this.searchs
      } else {
        return this.goods
      }
    }
  },
  created() {
    this.getYouMayAlsoLikeList()
  },
  mounted() {
    this.drag()
  },
  methods: {
    /**
     * API 获取猜你喜欢列表
     */
    async getYouMayAlsoLikeList() {
      let { data } = await API.getYouMayAlsoLikeList()
      if (data) {
        this.goods = data.map((item) => {
          if (item.imgUrl) {
            item.imgUrl = `${item.imgUrl}?x-oss-process=image/resize,w_148,h_147,m_fill/format,webp`
          }
          return item
        })
      }
    },

    /**
     * API 根据SPU查询猜你喜欢商品信息
     *
     * @param {Array} spus 需要添加的SPU列表
     */
    async getYouMayAlsoLikeListBySpu(spus) {
      let { code, message, data } = await API.getYouMayAlsoLikeListBySpu(spus)
      if (code === 10000) {
        if (data) {
          let result = data.map((item) => {
            if (item.imgUrl) {
              item.imgUrl = `${item.imgUrl}?x-oss-process=image/resize,w_148,h_147,m_fill/format,webp`
            }
            return item
          })
          this.goods = cloneDeep([...this.goods, ...result])
        }
        this.clearBatchAdd()
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    /**
     * API 添加猜你喜欢商品
     *
     * @param {Array} spus 需要添加的SPU列表
     */
    async addYouMayAlsoLikeListGoods(spus) {
      let { code, message } = await API.addYouMayAlsoLikeListGoods(spus)
      if (code === 10000) {
        // 销毁拖拽插件实例后重建
        this.destroySortable()
        this.getYouMayAlsoLikeList()
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    /**
     * API 检查SPU是否正确
     *
     * @param {Array} spus 需要检查的列表
     */
    async inspectSpuIsExactness(spus) {
      let { code, message, data } = await API.inspectSpuIsExactness(spus)
      if (code === 10000) {
        return data
      } else {
        this.$message.error(message)
        return {
          success: [],
          fail: []
        }
      }
    },

    /**
     * 初始化拖拽功能
     * 插件中文文档: https://www.itxst.com/sortablejs/neuinffi.html
     * 插件官方文档: https://github.com/SortableJS/Sortable/tree/master/plugins/MultiDrag
     */
    drag() {
      let element = document.getElementById('kaka-drag-goods')
      if (element) {
        this.sortable = new Sortable(element, {
          handle: '.kaka-drag-good-img', // 句柄（鼠标需按住有该类的元素才可以拖拽）
          draggable: '.kaka-drag-good', // 可拖拽的元素（必须拥有该类名的元素才能被拖拽）
          animation: 500, // 拖拽的动画执行时间
          dataIdAttr: 'data-good-id', // 自定义CSS属性（sortable.toArray()可获取该值）
          multiDrag: true, // 是否开启多选拖拽（注意：需要注册多选拖拽功能）
          selectedClass: 'selected', // 多选拖拽时的选中样式
          disabled: this.disabled, // 是否禁止拖拽
          avoidImplicitDeselect: true, // 不可以点击盒子外的区域取消选中
          fallbackTolerance: 3, // 兼容手机端
          // 选中项目时的回调
          onSelect: (event) => {
            this.selectIds = this.getGoodIds(event.items)
          },
          // 取消选择项目时调用
          onDeselect: (event) => {
            this.selectIds = this.getGoodIds(event.items)
          },
          onEnd: () => {
            let goods = cloneDeep(this.goods)
            let ids = this.getIsTopIds()
            let result = []
            ids.forEach((id) => {
              goods.forEach((good) => {
                if (id === good.kkProductId) {
                  result.push(good)
                }
              })
            })
            this.goods = result
          }
        })
      }
    },

    /**
     * 销毁排序实例
     */
    async destroySortable() {
      (await this.sortable) && this.sortable.destroy()
      this.drag()
    },

    /**
     * 获取当前所有已选项的Ids
     *
     * @param {Array} arr 已选项数组
     * @return {Array} 返回已选项IDs
     */
    getGoodIds(arr) {
      return arr.map((item) => Number.parseInt(item.getAttribute('data-good-id')))
    },

    /**
     * 获取当前列表排序后的IDs
     */
    getIsTopIds() {
      let element = document.getElementById('kaka-drag-goods')
      if (element) {
        return Array.from(element.children).map((item) => {
          return Number.parseInt(item.getAttribute('data-good-id'))
        })
      } else {
        return []
      }
    },

    /**
     * 清空批量添加的文本域数据
     */
    clearBatchAdd() {
      this.spus = undefined
    },

    /**
     * 确定批量添加的文本域数据
     */
    async defineBatchAdd() {
      if (this.spus) {
        if (this.goods.length === this.limitQuantity) {
          this.$message.info(`已超出${this.limitQuantity}个商品上限，请删除一些商品后再做添加！`)
          return
        }

        // 获取已有商品的SPUs
        let goodSpus = this.goods.map((item) => item.spuCode)
        // 获取用户输入的SPUs
        let textareaSpus = uniq(
          this.spus
            .trim()
            .split(/[\r\n]+/)
            .filter(Boolean)
            .map((item) => item.trim())
        )

        let result = [] // 未存在的数据
        let repeat = [] // 已存在的数据
        textareaSpus.forEach((item) => {
          if (goodSpus.includes(item)) {
            repeat.push(item)
          } else {
            result.push(item)
          }
        })

        if (goodSpus.length + result.length > this.limitQuantity) {
          this.$message.info(`已存在的数据加上本次添加的数据，已超出${this.limitQuantity}个商品上限，请删除一些商品或数据后再做添加！`)
          return
        }

        let data = {
          fail: [],
          success: []
        }
        if (result.length) {
          data = await this.inspectSpuIsExactness({ spus: result })
        }

        if (repeat.length || data.fail.length) {
          this.$confirm(
            `<div>
              <h4 style="color: #d14a4a;">检测到异常数据：</h4>
              <p>
                <strong>1.已存在的数据：</strong>
                <span>${repeat.join('、') ? repeat.join('、') : '无'}</span>
              </p>
              <p>
                <strong>2.可添加的数据：</strong>
                <span>${data.success.join('、') ? `${data.success.join('、')}` : '无'}</span>
              </p>
              <p>
                <strong>3.无法添加的数据：</strong>
                <span>${data.fail.join('、') ? `${data.fail.join('、')}` : '无'}</span>
              </p>
            </div>`,
            '确认信息',
            {
              showClose: false,
              customClass: 'message-box',
              closeOnClickModal: false,
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确认',
              cancelButtonText: '放弃添加',
              showConfirmButton: data.success.length ? true : false
            }
          )
            .then(() => {
              this.getYouMayAlsoLikeListBySpu(data.success)
            })
            .catch(() => {
              this.$message.info('已放弃添加')
            })
        } else {
          this.getYouMayAlsoLikeListBySpu(data.success)
        }

        // // 已存在的数据
        // let same = this.getSame(textareaSpus, goodSpus)

        // // 未存在的数据
        // let diff = this.getDiff(same, textareaSpus)

        // // 获取还可添加的数量
        // let difference = this.limitQuantity - this.goods.length

        // if (goodSpus.length + textareaSpus.length > this.limitQuantity || same.length || diff.length > difference) {
        //   // 最终发起请求的数据
        //   let result = []
        //   if (diff.length > difference) {
        //     for (let i = 0; i < difference; i++) {
        //       result.push(diff[i])
        //     }
        //   } else {
        //     result = [...diff]
        //   }

        //   // 获取多余的值
        //   let surplus = []
        //   diff.forEach((item) => {
        //     if (!result.includes(item)) {
        //       surplus.push(item)
        //     }
        //   })

        //   this.$confirm(
        //     `<div>
        //       <h4 style="color: #d14a4a;">检测到异常数据：</h4>
        //       <p>
        //         <strong>1.已存在的数据：</strong>
        //         <span>${same.join('、') ? same.join('、') : '无'}</span>
        //       </p>
        //       <p>
        //         <strong>2.可添加的数据：</strong>
        //         <span>${result.join('、') ? `${result.join('、')}（暂未校验是否为合法的SPU！）` : '无'}</span>
        //       </p>
        //       <p>
        //         <strong>3.无法添加的数据：</strong>
        //         <span>${surplus.join('、') ? `${surplus.join('、')}（原因为超出${this.limitQuantity}个商品的添加上限！）` : '无'}</span>
        //       </p>
        //     </div>`,
        //     '确认信息',
        //     {
        //       showClose: false,
        //       customClass: 'message-box',
        //       closeOnClickModal: false,
        //       dangerouslyUseHTMLString: true,
        //       confirmButtonText: '确认',
        //       cancelButtonText: '放弃添加',
        //       showConfirmButton: result.length ? true : false
        //     }
        //   )
        //     .then(() => {
        //       this.getYouMayAlsoLikeListBySpu(result)
        //     })
        //     .catch(() => {
        //       this.$message.info('已放弃添加')
        //     })
        // } else {
        //   this.getYouMayAlsoLikeListBySpu(textareaSpus)
        // }
      }
    },

    /**
     * 获取两个数组相同的元素
     *
     * @param {Array} arr1 数组1
     * @param {Array} arr2 数组2
     * @return {Array} 相同的元素数组
     */
    getSame(arr1, arr2) {
      if (arr1 && arr2) {
        return [...new Set(arr1)].filter((item) => arr2.includes(item))
      } else {
        return []
      }
    },

    /**
     * 获取两个数组不同的元素
     *
     * @param {Array} arr1 数组1
     * @param {Array} arr2 数组2
     * @return {Array} 不同的元素数组
     */
    getDiff(arr1, arr2) {
      if (arr1 && arr2) {
        return arr1.concat(arr2).filter((item, index, arr) => arr.indexOf(item) === arr.lastIndexOf(item))
      } else {
        return []
      }
    },

    /**
     * 更新到前台
     */
    updateToReception() {
      this.$confirm('此操作将把已添加的商品同步更新到前台，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let spus = this.goods.map((item) => ({
            kkProductId: item.kkProductId,
            top: item.top
          }))
          this.addYouMayAlsoLikeListGoods(spus)
        })
        .catch(() => {
          this.$message.info('已取消更新')
        })
    },

    /**
     * 批量搜索清除内容的回调事件
     */
    handleClearBatchSearchOne() {
      this.keywords = []
      this.searchs = []
      this.disabled = false
      // 销毁拖拽插件实例后重建
      this.destroySortable()
    },

    /**
     * 批量搜索的回调事件
     *
     * @param {String} value 搜索关键字数组
     */
    handleSearchBatchSearchOne(value) {
      this.keywords = [...value]
      if (this.keywords.length) {
        this.getSearchResult()
      } else {
        this.handleClearBatchSearchOne()
      }
    },

    /**
     * 获取当前搜索的商品信息
     */
    getSearchResult() {
      let isTop = []
      let goods = []
      this.searchs = []
      this.keywords.forEach((keyword) => {
        this.goods.forEach((good) => {
          if (keyword === good.spuCode) {
            this.searchs.push({ ...good })
          }
        })
      })
      this.searchs.forEach((item) => {
        if (item.top === 1) {
          isTop.push(item)
        } else {
          goods.push(item)
        }
      })
      this.searchs = unionWith(isTop, goods, isEqual)
      this.disabled = true
      // 销毁拖拽插件实例后重建
      this.destroySortable()
    },

    /**
     * 一键删除
     */
    oneClickDeletion() {
      if (this.selectIds.length) {
        this.$confirm(
          `<div>
            <strong>此操作将删除以下 <span style="color: #f56c6c;">已选中</span> 的商品，是否继续？</strong>
            <p>${this.getSpuCode().join('、')}</p>
          </div>`,
          '确认信息',
          {
            showClose: false,
            customClass: 'message-box',
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确认',
            cancelButtonText: '放弃删除'
          }
        )
          .then(() => {
            this.removeGoods()
            this.$message.success('删除成功')
          })
          .catch(() => {
            this.$message.info('已放弃删除')
          })
      } else {
        this.$confirm('此操作将删除所有已添加的商品，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.goods = []
            // 销毁拖拽插件实例后重建
            this.destroySortable()
            this.$message.success('删除成功')
          })
          .catch(() => {
            this.$message.info('已放弃删除')
          })
      }
    },

    /**
     * 根据商品Id获取SpuCode
     *
     * @return {Array} SpuCodes
     */
    getSpuCode() {
      let spuCodes = []
      this.goods.forEach((item) => {
        if (this.selectIds.includes(item.kkProductId)) {
          spuCodes.push(item.spuCode)
        }
      })
      return spuCodes
    },

    /**
     * 根据商品Ids移除指定位置的商品
     */
    removeGoods() {
      this.selectIds.forEach((id) => {
        this.goods.forEach((item, index) => {
          if (id === item.kkProductId) {
            this.goods.splice(index, 1)
          }
        })
      })
      // 销毁拖拽插件实例后重建
      this.destroySortable()
    },

    /**
     * 点击复制ICon的回调事件
     */
    onCopy(spuCode, event) {
      event.stopPropagation()
      copy(spuCode)
    },

    /**
     * 点击置顶ICon的回调事件
     *
     * @param {Object} good 当前点击的商品
     */
    onIsTopGood(good, event) {
      event.stopPropagation()
      if (good.top === 0) {
        let sum = 0
        this.goods.forEach((item) => {
          if (item.top === 1) {
            sum += 1
          }
        })
        if (sum >= this.isTopSum) {
          this.$message.warning(`最多只能置顶 ${this.isTopSum} 个商品`)
          return
        }
      }
      this.renewIsTopData(1, this.goods, good.kkProductId, good.top === 0 ? 1 : 0) // 原始数据
      if (this.searchs.length) {
        this.renewIsTopData(2, this.searchs, good.kkProductId, good.top === 0 ? 1 : 0) // 搜索数据
      }
    },

    /**
     * 根据置顶指示重排数据
     *
     * @param {Number} type 1.原始数据 2.搜索数据
     * @param {Array} data 需要操作的数据
     * @param {Number} id 需要置顶的数据ID
     * @param {Boolean} top 置顶/取消
     */
    async renewIsTopData(type, data, id, top) {
      if (data && data.length) {
        let isTop = []
        let goods = cloneDeep(data)
        if (top === 1) {
          // 置顶
          await goods.forEach((item) => {
            if (item.top === 1 || item.kkProductId === id) {
              isTop.push(item)
              item.kkProductId === id && (item.top = top)
            }
          })
        } else {
          // 取消
          await goods.forEach((item) => {
            if (item.kkProductId === id) {
              item.top = top
            }
          })
          await goods.forEach((item) => {
            if (item.top === 1) {
              isTop.push(item)
            }
          })
        }
        if (isTop.length) {
          isTop.forEach((item) => {
            goods.forEach((good, index) => {
              if (item.kkProductId === good.kkProductId) {
                goods.splice(index, 1)
              }
            })
          })
        }
        // 合并置顶和非置顶元素并去除重复元素
        if (type === 1) {
          this.goods = unionWith(isTop, goods, isEqual)
        }
        if (type === 2) {
          this.searchs = unionWith(isTop, goods, isEqual)
        }
        // 销毁拖拽插件实例后重建
        this.destroySortable()
      }
    },

    /**
     * 点击删除ICon的回调
     *
     * @param {Object} good 当前点击的商品
     */
    onDeleteGood(good, event) {
      event.stopPropagation()
      if (this.searchs.length) {
        this.searchs.forEach((item, index) => {
          if (item.kkProductId === good.kkProductId) {
            this.searchs.splice(index, 1)
          }
        })
      }
      this.goods.forEach((item, index) => {
        if (item.kkProductId === good.kkProductId) {
          this.goods.splice(index, 1)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 12px;
  background-color: #fff;

  .header {
    .popover-tips {
      color: #99c41c;
      font-size: 12px;
    }
    .footer-botton {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .tips {
        color: #d14a4a;
        font-size: 12px;
      }
    }
    .spus-input {
      margin-top: 5px;
      margin-bottom: 12px;
    }
    .update-button {
      margin-left: 12px;
    }
    .header-search {
      display: flex;
      margin: 12px 0;
      align-items: center;
      justify-content: space-between;
      .search {
        display: flex;
        flex-direction: column;
        .tips {
          color: #bdbdbd;
          font-size: 12px;
          margin-top: 5px;
          line-height: 18px;
        }
      }
    }
  }

  .not-data {
    display: flex;
    height: 100%;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background-color: #fff;
    .tips-text {
      color: #bdbdbd;
      font-size: 14px;
      margin-top: 28px;
    }
  }

  .goods {
    display: grid;
    grid-gap: 12px 12px;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 142px);
    overflow: auto;

    .good {
      display: flex;
      position: relative;
      width: 142px;
      height: 205px;
      padding: 8px;
      overflow: hidden;
      flex-direction: column;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      &:hover {
        cursor: no-drop;
        .good-img {
          &.no-drop {
            cursor: no-drop;
          }
        }
        .footer {
          display: block;
        }
      }

      .good-img {
        flex: 1;
        overflow: hidden;
        cursor: move;
        border-radius: 4px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .spu,
      .price {
        color: #10141d;
        font-size: 12px;
        margin-top: 5px;
      }

      .istop-img {
        position: absolute;
        top: 0;
        right: 0;
        width: 32px;
      }

      .footer {
        display: none;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 35px;
        line-height: 35px;
        text-align: center;
        background: rgba(0, 0, 0, 0.58);
        i {
          display: inline-block;
          margin-right: 12px;
          color: #fff;
          font-weight: 400;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
          &.icon-fuzhi1:hover,
          &.icon-igw-l-sign:hover {
            color: #99c41c;
          }
          &.icon-a-delete-bin-6-line5:hover {
            color: #f56c6c;
          }
        }
        .active {
          color: #99c41c;
          transform: rotate(-42deg);
        }
      }
    }
  }

  .selected {
    background: rgba(153, 196, 28, 0.06) !important;
    border: 1px solid #99c41c !important;
    z-index: 1 !important;
  }
}
</style>
